import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: fetchBaseQuery({
        credentials: 'include',
        prepareHeaders: (headers, api) => {
            headers.set('Accept', 'application/json')
            headers.set('Content-Type', 'application/json')
            headers.set('X-CT-SOURCETYPE', 'web')

            if (api.endpoint === 'userProfileDetails') {
                headers.set('caller', 'flyin')
            }

            return headers
        }
    }),
    endpoints: builder => ({
        signIn: builder.mutation<any, { username: string; password: string }>({
            query: body => ({
                url: '/v2/signin',
                method: 'POST',
                body
            })
        }),
        signUp: builder.mutation<any, any>({
            query: body => ({
                url: '/flight/search/v2/signup',
                method: 'POST',
                body
            })
        }),
        resetPassword: builder.mutation<any, { email: string }>({
            query: ({ email }) => ({
                url: `/accounts-api/v2/user/resetPassword?email=${encodeURIComponent(email)}`,
                method: 'POST'
            })
        }),
        userProfileDetails: builder.query<any, void>({
            query: () => ({
                url: `/flight/search/v2/user-details`,
                method: 'GET'
            })
        }),
        userLogout: builder.query<any, void>({
            query: () => ({
                url: `/flight/search/v2/logout`,
                method: 'GET'
            })
        })
    })
})

export const {
    useSignInMutation,
    useSignUpMutation,
    useResetPasswordMutation,
    useUserProfileDetailsQuery,
    useLazyUserProfileDetailsQuery,
    useUserLogoutQuery,
    useLazyUserLogoutQuery,
} = userApi
export default userApi
